import {useState} from 'react'
import {getPoint} from '../services'
import {PointModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const usePointList = () => {
  const [loading, setLoading] = useState(false)
  const [pointList, setPointList] = useState<SelectModel[]>([])

  const getPointAPI = async (pointParams: PointModel) => {
    let obj: PointModel = {
      isCombo: true,
      ...pointParams,
    }
    return await getPoint(obj, 1)
  }

  const getPointData = async (pointParams: PointModel) => {
    setLoading(true)
    try {
      const response = await getPointAPI(pointParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching point data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updatePointList = (mappedSites: {value: string; label: string}[]) => {
    setPointList(mappedSites)
  }
  const getPointMappedData = async (pointParams: PointModel) => {
    try {
      const data = await getPointData(pointParams)
      const mappedSites = mapDataSelect(data)
      return mappedSites
    } catch (error) {
      console.error('Error fetching point data:', error)
    }
  }
  const getPointList = async (pointParams: PointModel = {}) => {
    try {
      const data = await getPointData(pointParams)
      const mappedSites = mapDataSelect(data)
      updatePointList(mappedSites)
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }

  const handleClear = () => {
    setPointList([])
  }

  return {
    loading,
    pointList,
    getPointList,
    handleClear,
    getPointMappedData,
  }
}

export default usePointList
